<template>
  <div>
    <div
      id="footer"
      class=""
      style="width: 100%; background: #0977b9; padding: 30px 0 30px; clear: both; text-align: center; margin: 0px auto 0;"
    >
      <div
        style="overflow: auto; max-width: 1320px; margin: 0 auto; padding: 30px 0 30px;"
        class="footer-container"
      >
        <div
          class="col-md-4 footer-element-1"
          style="text-align: left; font-size: 13px"
        >
          <div class="col-md-7 no-padding-mobile">
            <img
              src="@/assets/images/flightsite_logo_white.png"
              class="footer-logo"
              alt="FlightSite.co.za"
              style="display: block; margin: 3px 0 20px; width: 80%;"
            />
            <p style="color: #fff;">
              Offering 24/7 traveller support &amp; dedicated staff, it's no
              surprise that more South African travelers are choosing FlightSite
              for business and leisure travel. Making travel easy since 2009.
            </p>
          </div>
          <div
            class="col-md-5  no-padding-mobile"
            style="text-align: left; padding-right: 0px;"
          >
            <h4>
              <i class="fa fa-lg fa-info" aria-hidden="true"></i>&nbsp; Company
            </h4>
            <ul>
              <li>
                <a href="https://travel.flightsite.co.za/travel/about/" target="_self"
                  ><i
                    class="fa fa-lg fa-plane"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; About</a
                >
              </li>
              <li>
                <a href="http://blog.flightsite.co.za" target="_blank"
                  ><i
                    class="fa fa-lg fa-plane"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Blog</a
                >
              </li>
              <li>
                <a href="https://travel.flightsite.co.za/travel/frequently-asked-questions/" target="_self"
                  ><i
                    class="fa fa-lg fa-plane"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; FAQs</a
                >
              </li>
              <li>
                <a href="https://travel.flightsite.co.za/travel/contact-us/" target="_self"
                  ><i
                    class="fa fa-lg fa-plane"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Contact</a
                >
              </li>
              <li>
                <a href="https://travel.flightsite.co.za/services-products-travel-insurance/" target="_self"
                  ><i
                    class="fa fa-lg fa-plane"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Products & Services</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-2" style="text-align: left; ">
          <h4>
            <i class="fa fa-lg fa-plane" aria-hidden="true"></i>&nbsp; Airlines
          </h4>
          <ul>
            <li>
              <a href="https://travel.flightsite.co.za/travel/airlines/sa-airlink/" target="_self"
                ><i
                  class="fa fa-lg fa-plane"
                  aria-hidden="true"
                  style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                ></i
                >&nbsp; Airlink</a
              >
            </li>
            <li>
              <a href="https://travel.flightsite.co.za/travel/airlines/south-african-airways/" target="_self"
                ><i
                  class="fa fa-lg fa-plane"
                  aria-hidden="true"
                  style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                ></i
                >&nbsp; South African Airways</a
              >
            </li>
            <li>
              <a href="https://travel.flightsite.co.za/travel/airlines/british-airways/" target="_self"
                ><i
                  class="fa fa-lg fa-plane"
                  aria-hidden="true"
                  style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                ></i
                >&nbsp; British Airways</a
              >
            </li>
            <li>
              <a href="https://travel.flightsite.co.za/travel/airlines/flysafair-flights/" target="_self"
                ><i
                  class="fa fa-lg fa-plane"
                  aria-hidden="true"
                  style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                ></i
                >&nbsp; FlySafair</a
              >
            </li>
            <li>
              <a href="https://travel.flightsite.co.za/travel/airlines/emirates-airline/" target="_self"
                ><i
                  class="fa fa-lg fa-plane"
                  aria-hidden="true"
                  style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                ></i
                >&nbsp; Emirates Airlines</a
              >
            </li>
            <li>
              <a href="https://travel.flightsite.co.za/travel/airlines/qatar-airways/" target="_self"
                ><i
                  class="fa fa-lg fa-plane"
                  aria-hidden="true"
                  style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                ></i
                >&nbsp; Qatar Airways</a
              >
            </li>
            <li>
              <a href="https://travel.flightsite.co.za/travel/airlines/air-france/" target="_self"
                ><i
                  class="fa fa-lg fa-plane"
                  aria-hidden="true"
                  style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                ></i
                >&nbsp; Air France</a
              >
            </li>
            <li>
              <a href="https://travel.flightsite.co.za/travel/airlines/klm/" target="_self"
                ><i
                  class="fa fa-lg fa-plane"
                  aria-hidden="true"
                  style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                ></i
                >&nbsp; KLM</a
              >
            </li>
            <li>
              <a href="https://travel.flightsite.co.za/travel/airlines/turkish-airlines/" target="_self"
                ><i
                  class="fa fa-lg fa-plane"
                  aria-hidden="true"
                  style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                ></i
                >&nbsp; Turkish Airlines</a
              >
            </li>
          </ul>
        </div>
        <div class="col-md-3" style="text-align: left;">
          <h4>
            <i
              class="fa fa-lg fa-map-signs"
              aria-hidden="true"
              style="font-size: 20px;line-height:0;"
            ></i
            >&nbsp; Popular Routes
          </h4>
          <ul>
            <ul>
              <li>
                <a
                  href="https://travel.flightsite.co.za/travel/routes/flights-cape-town-bloemfontein/"
                  target="_self"
                  ><i
                    class="fa fa-lg fa-map-marker"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Cape Town to Bloemfontein</a
                >
              </li>
              <li>
                <a
                  href="https://travel.flightsite.co.za/travel/routes/flights-cape-town-east-london/"
                  target="_self"
                  ><i
                    class="fa fa-lg fa-map-marker"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Cape Town to East London</a
                >
              </li>
              <li>
                <a
                  href="https://travel.flightsite.co.za/travel/routes/flights-johannesburg-port-elizabeth/"
                  target="_self"
                  ><i
                    class="fa fa-lg fa-map-marker"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Johannesburg to Port Elizabeth</a
                >
              </li>
              <li>
                <a
                  href="https://travel.flightsite.co.za/travel/routes/flights-durban-johannesburg/"
                  target="_self"
                  ><i
                    class="fa fa-lg fa-map-marker"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Durban to Johannesburg</a
                >
              </li>
              <li>
                <a
                  href="https://travel.flightsite.co.za/travel/routes/cape-town-johannesburg-flights/"
                  target="_self"
                  ><i
                    class="fa fa-lg fa-map-marker"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Cape Town to Johannesburg</a
                >
              </li>
              <li>
                <a
                  href="https://travel.flightsite.co.za/travel/routes/flights-durban-cape-town/"
                  target="_self"
                  ><i
                    class="fa fa-lg fa-map-marker"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Durban to Cape Town</a
                >
              </li>
              <li>
                <a
                  href="https://travel.flightsite.co.za/travel/routes/flights-johannesburg-dubai/"
                  target="_self"
                  ><i
                    class="fa fa-lg fa-map-marker"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Johannesburg to Dubai</a
                >
              </li>
              <li>
                <a href="https://travel.flightsite.co.za/travel/routes/flights-cape-town-dubai/" target="_self"
                  ><i
                    class="fa fa-lg fa-map-marker"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Cape Town to Dubai</a
                >
              </li>
              <li>
                <a
                  href="https://travel.flightsite.co.za/travel/routes/flights-johannesburg-london/"
                  target="_self"
                  ><i
                    class="fa fa-lg fa-map-marker"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Johannesburg to London</a
                >
              </li>
              <li>
                <a
                  href="https://travel.flightsite.co.za/travel/routes/flights-cape-town-london/"
                  target="_self"
                  ><i
                    class="fa fa-lg fa-map-marker"
                    aria-hidden="true"
                    style="font-size: 14px; line-height: 0.1; color: #21a5f3;"
                  ></i
                  >&nbsp; Cape Town to London</a
                >
              </li>
            </ul>
          </ul>
        </div>
        <div class="col-md-3" style="float: left; text-align: left; ">
          <h4>
            <i
              class="fa fa-lg fa-envelope"
              aria-hidden="true"
              style="font-size: 20px; margin-top: -4px;margin-bottom: 5px;line-height: 0;"
            ></i
            >&nbsp; Get the latest news and specials
          </h4>
          <div>
            <form
              action="//flightsite.us2.list-manage.com/subscribe/post?u=193b7fff0e02160a8aaeea0fe&amp;id=8e904a829a"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              target="_blank"
              class="ng-pristine ng-valid"
            >
              <div class="col-md-7" style="padding:0px">
                <input
                  type="email"
                  value=""
                  name="EMAIL"
                  id="mce-EMAIL"
                  style="border-radius: 0px; background: #fff; border: none; width: 150px; height: 40px; padding-left: 0px; margin-left: 0px;"
                  class="form-control"
                />
              </div>
              <div class="col-md-4" style="padding: 0px;">
                <input
                  style="height: 40px; border: none; background-color: #1b567a; color: #fff; font-weight: bold; padding: 0px 20px"
                  type="submit"
                  value="SIGNUP"
                />
              </div>
              <div
                style="position: absolute; left: -5000px;"
                aria-hidden="true"
              >
                <input
                  type="text"
                  name="b_193b7fff0e02160a8aaeea0fe_8e904a829a"
                  tabindex="-1"
                  value=""
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      id="footer-band"
    >
      <img
        src="@/assets/images/accreditation-iata.png"
        alt="IATA"
        style="height: 49px; width: 63px; opacity: 0.3;"
      />
      <img
        src="@/assets/images/accreditation-asata.png"
        alt="ASATA"
        class="middle"
        style="height: 49px; width: 69px;"
      />
      <img
        src="@/assets/images/accreditation-winner.png"
        alt="Travel Awards Winner"
        style="height: 49px; width: 51px;"
      />
    </div>

    <div class="">
      <div class="col-md-12" style="text-align: center; padding: 20px;">
        <img src="@/assets/images/thawte.png" alt="THAWTE" height="30px" class="image-box"/>
        <img
          src="@/assets/images/verified-by-visa.png"
          alt="Verified by VISA"
          hspace="10"
          height="30px"
          class="image-box"
        />
        <img
          src="@/assets/images/mastercard-securecode.png"
          alt="Mastercard Securecode"
          height="30px"
          class="image-box"
        />
        <img src="@/assets/images/amex.png" hspace="10" alt="AMEX" height="30px" class="image-box"/>
        <img
          src="@/assets/images/icon-pnp.png"
          alt="Pick n Pay"
          hspace="10"
          height="30px"
          class="image-box"
        />
      </div>
    </div>

    <div class="col-md-12"
    style="text-align: center;">
      In association with the <a href="https://www.travelstart.co.za">Travelstart Group</a>.
    </div>

    <div
    class="col-md-12"
    style="text-align: center; padding: 20px 0;"
    >
        <p style="font-size: 12px;">
            &copy; 2021 FlightSite |
            <a target="_blank" href="https://travel.flightsite.co.za/travel/terms-and-conditions/" class="footer-action">Terms and Conditions</a> |
            <a target="_blank" href="https://travel.flightsite.co.za/privacy-policy/" class="footer-action">Privacy Policy</a>
        </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlightsiteFooter"
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

#footer h4 {
  font-weight: normal;
  letter-spacing: 0.5px;
  margin: 0 0 20px 0;
  color: #fff;
}

.image-box {
    height: 30px;
}

.footer-action {
    color: #959595;
    text-decoration: none;
}

.footer-action::after {
    color: #959595;
    text-decoration: none;
}

.footer-action:hover {
    color: #959595;
    text-decoration: none;
}

#footer ul {
  margin: 0;
  padding: 0;
}

#footer ul li {
  list-style: none;
  margin: 0 0 3px 5px;
  padding: 0;
}

#footer ul li a {
  text-decoration: none;
  color: #87d0fc;
  font-size: 13px;
}

#footer ul li a:hover {
  color: #fff;
}

#footer p {
  color: #87d0fc;
  margin-right: 20px;
}

#footer-band {
    width: 100%; background: #1b567a; padding: 20px; display: flex; padding: 30px; width: 100%;
    justify-content: center;
    .middle {
        margin-left: 10px;
        margin-right: 10px;
    }
}

.reference-bar {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-end;
  max-width: 1080px;
  margin: auto;
  flex-wrap: wrap;
}

.home-icon {
  text-align: center;
  padding-top: 20px;
  width: 100%;
}

@media (min-width: 781px) {
  .home-icon {
    width: unset;
  }
}
</style>
